import React from 'react';
import PropTypes from 'prop-types';
import { Loading } from 'components/Loading';
import Row from './Row';

const SearchResults = ({
  onMouseDown,
  onItemClick,
  selectedIndex,
  loading,
  options,
  className,
}) => {
  const renderRow = (option, index) => (
    <Row
      key={index + (option.jobId || '') + (option.soId || '')}
      onItemClick={onItemClick}
      isSelected={index === selectedIndex}
      option={option}
    />
  );

  return (
    <div className={className} onMouseDown={onMouseDown} data-testid="search-results">
      {loading && <Loading size={16} className="search-results__loading" />}
      {!loading && options.map(renderRow)}
      {!loading && options.length === 0 && <Row />}
    </div>
  );
};

SearchResults.defaultProps = {
  options: [],
};

SearchResults.propTypes = {
  fieldValue: PropTypes.string,
  selectedIndex: PropTypes.number,
  loading: PropTypes.bool,
  onItemClick: PropTypes.func,
  onMouseDown: PropTypes.func,
  options: PropTypes.array,
  className: PropTypes.string,
};

export default SearchResults;
